import { formatDistanceToNow } from 'date-fns'

/** Friendly names for the wire `kind` values. Unknown kinds fall through to the raw value. */
export const CRASH_KIND_LABEL: Record<string, string> = {
  JsFatal: 'JS crash',
  JsRender: 'Screen crash',
  NativeCrash: 'Native crash',
  Anr: 'App froze (ANR)',
  LowMemory: 'Out of memory',
  Other: 'Other',
}

export const CRASH_KIND_COLOR: Record<string, 'error' | 'warning' | 'info' | 'default'> = {
  JsFatal: 'error',
  JsRender: 'warning',
  NativeCrash: 'error',
  Anr: 'warning',
  LowMemory: 'info',
  Other: 'default',
}

export function crashKindLabel(kind: string): string {
  return CRASH_KIND_LABEL[kind] ?? kind
}

export const CRASH_WINDOWS = [7, 30, 90] as const

export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return '—'
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return '—'
  return formatDistanceToNow(date, { addSuffix: true })
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—'
  return new Date(iso).toLocaleString()
}

/** "1.4.2 (291)", "1.4.2", "(291)" or a dash. */
export function formatVersion(appVersion: string | null | undefined, build: string | null | undefined): string {
  if (appVersion && build) return `${appVersion} (${build})`
  if (appVersion) return appVersion
  if (build) return `(${build})`
  return '—'
}

export function formatPlatform(platform: string | null | undefined): string {
  if (!platform) return '—'
  const p = platform.toLowerCase()
  if (p === 'ios') return 'iOS'
  if (p === 'android') return 'Android'
  return platform
}
